// extracted by mini-css-extract-plugin
export var attachment = "_pv-a";
export var emailContainer = "_pv-4";
export var emailContentPaddedContainer = "_pv-b";
export var emailHeader = "_pv-6";
export var emailIframe = "_pv-3";
export var emailInfoIcon = "_pv-9";
export var emailShortenedSummary = "_pv-e";
export var infoDropdown = "_pv-0";
export var infoRowBoundedContent = "_pv-d";
export var internal = "_pv-5";
export var merchant = "_pv-8";
export var messageInputContainer = "_pv-h";
export var normal = "_pv-7";
export var replyCard = "_pv-f";
export var subtleButton = "_pv-1";
export var subtleButtonIconContainer = "_pv-2";
export var toggleViewRepliesButton = "_pv-c";
export var wrappingText = "_pv-g";